export default __webpack_public_path__ + "static/media/step4-icon.ba057b2f.svg";